import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../services/profile.service';
import { RoutePath } from '../enums/api.enum';

export const manageAutomationGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const config = profileService.userProfile()?.config;
  if (config?.canManageWorkflows || config?.isAdmin) {
    return true;
  } else {
    router.navigate([`/${RoutePath.Session}`]);
    return false;
  }
};

export const myAutomationGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const config = profileService.userProfile()?.config;
  if (config?.canManageWorkflows || config?.canCreateWorkflows || config?.isAdmin) {
    return true;
  } else {
    router.navigate([`/${RoutePath.Session}`]);
    return false;
  }
};

export const useAutomationGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const config = profileService.userProfile()?.config;
  if (config?.canManageWorkflows || config?.canCreateWorkflows || config?.canUseWorkflows || config?.isAdmin) {
    return true;
  } else {
    router.navigate([`/${RoutePath.Session}`]);
    return false;
  }
};
